"use strict";
const _ = require('lodash');
_.mixin(require('lodash-uuid'));
function literToAppropriateUnit(liter) {
    if (liter > 1) {
        return `${liter} l`;
    }
    return `${liter * 1000} ml`;
}
module.exports = literToAppropriateUnit;
